import { WithStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import * as React from 'react';
import { connect } from 'react-redux';
import { StaticContext } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';

import * as Stickyfill from 'stickyfilljs';
import {
	IApply,
	IApprovalSearchCondition,
	ICareerSearchCondition,
	ISelectedCareer,
	setApplicationSelectedCareers,
	setCareerSearchCondition,
} from '../actions/search';
import Approvals from '../components/Approvals';
import SearchSteper from '../components/SearchSteper';
import SearchDetail, { SearchDetailTypes } from '../containers/SearchDetail';
import { IRootState } from '../reducers';
import ScenarioFactory from '../scenario/SearchScenarioFactory';
import { isMobile } from '../utils/MobileCheck';

const styles = (theme: Theme) =>
	createStyles({
		accessBar: {
			backgroundColor: '#e8eaf6',
			position: 'sticky',
			top: '0px',
			zIndex: 10,
		},
		appBar: {
			position: 'relative',
		},
		button: {
			margin: '10px',
		},
		flex: {
			flex: 1,
		},
		link: {
			color: 'blue',
			cursor: 'pointer',
		},
		root: {
			flexGrow: 1,
			padding: 18,
		},
		wrapDiv: {
			margin: '10px',
		},
	});

// tslint:disable-next-line:no-empty-interface
interface IRouteParams {}

interface IRouteState {
	careerIDs: IState['careerIDs'];
	careerType: ICareerSearchCondition['careerType'];
	applies: IState['applies'];
	targetCareerId: IState['targetCareerId'];
	caller: string;
	resultApply: boolean;
}

interface IState {
	activeStep: number;
	applyFlg?: string;
	applies?: IApply[];
	careerIDs?: string[];
	careerType?: string;
	onlyApply: boolean;
	targetCareerId?: string;
	resultApply: boolean;
	caller?: string;
}

/**
 * 受講申請
 */
class LectureApplication extends React.Component<IProps, IState> {
	public constructor(props: IProps) {
		super(props);

		this.state = {
			activeStep: 1,
			onlyApply: false,
			resultApply: false,
		};

		this.onApply = this.onApply.bind(this);
		this.setFirstStep = this.setFirstStep.bind(this);
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		window.scrollTo({
			top: 0,
		});
		if (!this.props.location || !this.props.location.state) {
			return;
		}

		// 申請対象クリア
		this.props.setApplicationSelectedCareers([]);

		const state = this.props.location.state;
		const resultApply = this.props.location.state.resultApply;
		const caller = this.props.location.state.caller;
		const { careerIDs, careerType, applies, targetCareerId } = state;
		const condition: ICareerSearchCondition = {
			assessment: false,
			careerType,
			categoryId: '',
			categoryName: '',
			detail: [],
			elearning: true,
			endDate: '',
			freeword: '',
			jobCategory: false,
			lowerFlg: false,
			office: false,
			onlyWanted: false,
			position: false,
			qualification: false,
			shugo: true,
			skillTypeList: [],
			sonota: false,
			startDate: '',
			tuusin: true,
			workExperience: false,
		};
		if (careerIDs && careerType) {
			// カテゴリ検索画面からの受講申請
			this.setState({
				activeStep: 1,
				careerIDs,
				careerType,
				onlyApply: false,
			});
			// careerIDsに紐付く研修・カリキュラムを検索
			condition.careerIDs = careerIDs;
			this.props.fetchDetailCareerListForApply(
				this.props.token,
				condition
			);
		} else if (applies && careerType) {
			// 詳細検索からの受講申請
			this.setState({
				activeStep: 2,
				onlyApply: true,
			});

			// appliesに紐付く研修・カリキュラムを検索
			const approvalCondition: IApprovalSearchCondition = {
				applies,
				careerType,
			};
			this.props.fetchApprovals(this.props.token, approvalCondition);
		} else if (targetCareerId && careerType) {
			// カリキュラム詳細内容からの受講申請
			this.setState({
				activeStep: 1,
				caller,
				careerType,
				onlyApply: false,
				resultApply,
				targetCareerId,
			});

			condition.targetCareerId = targetCareerId;
			condition.targetUserId = this.props.userAttr.userId;
			this.props.fetchDetailCareerListForApply(
				this.props.token,
				condition
			);
			this.props.setCareerSearchCondition(condition);
		}
	}

	public render() {
		const { classes } = this.props;
		const { activeStep } = this.state;

		return (
			<div className={classes.root}>
				{!isMobile() && (
					<Grid container={true}>
						<Grid item={true} xs={1} sm={3} md={3} />
						<Grid item={true} xs={10} sm={6} md={6}>
							<SearchSteper
								activeStep={this.state.activeStep}
								backFlg={!this.state.onlyApply}
								onSetActiveStep={this.setFirstStep}
							/>
						</Grid>
						<Grid item={true} xs={1} sm={3} md={3} />
					</Grid>
				)}
				{isMobile() && (
					<Grid
						container={true}
						justify="center"
						className={classes.accessBar}
						ref={(el: HTMLDivElement) => el && Stickyfill.add(el)}
					>
						<SearchSteper
							activeStep={this.state.activeStep}
							backFlg={!this.state.onlyApply}
							onSetActiveStep={this.setFirstStep}
						/>
					</Grid>
				)}
				<Grid container={true}>
					<Grid item={true} xs={12}>
						{this.getStepContent(activeStep)}
					</Grid>
				</Grid>
			</div>
		);
	}

	/**
	 * 対象選択に戻る
	 */
	protected setFirstStep() {
		const { activeStep } = this.state;
		if (activeStep === 1) {
			return;
		}
		this.setState({
			activeStep: 1,
		});
	}

	/**
	 * 表示内容取得
	 * @param step ステップ
	 */
	protected getStepContent(step: number) {
		if (step === 1) {
			return (
				<SearchDetail
					applyFlg={this.props.detailsForApply.applyFlg}
					data={this.props.detailsForApply.data}
					selectedCareers={this.props.detailsForApply.selectedCareers}
					selectedColumns={this.props.detailsForApply.selectedColumns}
					type={SearchDetailTypes.APPLY}
					onApply={this.onApply}
					resultApply={this.state.resultApply}
					caller={this.state.caller}
				/>
			);
		} else {
			return <Approvals caller={this.props.location.state.caller} />;
		}
	}

	/**
	 * 受講申請（対象選択後）
	 * @param applies 申請情報
	 * @param careerType キャリアタイプ
	 */
	protected onApply(applies: IApply[], careerType: string) {
		this.setState({
			activeStep: 2,
		});
		const condition: IApprovalSearchCondition = {
			applies,
			careerType,
		};
		this.props.fetchApprovals(this.props.token, condition);
	}
}

const mapStateToProps = (state: IRootState) => ({
	detailsForApply: state.search.detailsForApply,
	token: state.session.token,
	userAttr: state.session.userAttr,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	fetchApprovals: (token: string, condition: IApprovalSearchCondition) => {
		const s = ScenarioFactory.createFetchApprovals(dispatch, token);
		s.run(condition);
	},
	fetchDetailCareerListForApply: (
		token: string,
		condition: ICareerSearchCondition
	) => {
		const s = ScenarioFactory.createFetchDetailCareerListForApply(
			dispatch,
			token
		);
		s.run(condition);
	},
	setApplicationSelectedCareers: (selectedCareers: ISelectedCareer[]) =>
		dispatch(setApplicationSelectedCareers({ selectedCareers })),

	setCareerSearchCondition: (value: ICareerSearchCondition) =>
		dispatch(setCareerSearchCondition({ value })),
});

// tslint:disable-next-line: no-empty-interface
export interface ILectureApplicationProps {}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> &
	RouteComponentProps<IRouteParams, StaticContext, IRouteState> &
	ILectureApplicationProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(LectureApplication);

const Styled = withStyles(styles)(Connected);
const Export: React.ComponentType<ILectureApplicationProps> = Styled;

export default Export;



// WEBPACK FOOTER //
// ./src/containers/LectureApplication.tsx